var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.attributes),function(group,idx){return _c('li',{key:idx,class:{ 'mb-1': idx + 1 !== _vm.attributes.length }},[_c('sidebar-form',{attrs:{"attributes":group.elements,"label":group.label,"values":_vm.values}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }